<div class="perfiles-container">
  <div class="perfiles-header">

    <div class="filters">
      <p class="ps" style="margin: auto; display: flex; justify-content: center;">
        <span style="margin: auto;">{{variables?.statistics || 'Estadísticas'}} &nbsp; </span>
        <mat-icon (click)="showKPIs = !showKPIs">{{showKPIs ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}}</mat-icon>
      </p>
    </div>

  </div>

  <!-- KPIs -->
  @if (!isLoading && profiles.data.length > 0 && showKPIs) {
    <mat-divider class="filters-divider"> </mat-divider>

  <div class="kpi-container">
    <div class="kpi-card">
      <mat-icon class="kpi-icon">people</mat-icon>
      <div class="kpi-content">
        <span class="kpi-value">{{totalProfiles}}</span>
        <span class="kpi-label">{{variables?.totalProfiles || 'Total perfiles'}}</span>
      </div>
    </div>
    <div class="kpi-card">
      <mat-icon class="kpi-icon">euro_symbol</mat-icon>
      <div class="kpi-content">
        <span class="kpi-value">{{averageCost | number:'1.2-2'}} €/h</span>
        <span class="kpi-label">{{variables?.averageCostGeneral || 'Coste medio general'}}</span>
      </div>
    </div>
    <div class="kpi-row-break"></div>
    @for (ck of centerKPIs; track ck) {
    <div class="kpi-card center-kpi">
      <mat-icon class="kpi-icon">location_city</mat-icon>
      <div class="kpi-content">
        <span class="kpi-value">{{ck.averageCost | number:'1.2-2'}} €/h</span>
        <span class="kpi-label">{{ck.center}} ({{ck.count}})</span>
      </div>
    </div>
    }
  </div>
  }

    <mat-divider class="filters-divider"> </mat-divider>
  
  <div class="profile-section-header">
    <div>
      <h2 class="profile-title">{{variables?.profiles || 'Perfiles'}}</h2>
      <p class="subtitle">{{variables?.profilesSubtitle || 'Los perfiles definen el coste por hora de cada rol
        profesional utilizado en las estimaciones.'}}</p>
    </div>

    <div class="filters">
      <p class="ps" style="margin: auto; display: flex; justify-content: center;">
        <span style="margin: auto;">{{variables?.filters || 'Filtros'}} &nbsp; </span>
        <mat-icon (click)="showCostCenterFilter = !showCostCenterFilter">{{showCostCenterFilter ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}}</mat-icon>
      </p>
    </div>

  </div>

    <mat-divider class="filters-divider"> </mat-divider>

  @if (isLoading) {
  <div class="loading-container">
    <mat-spinner diameter="40"></mat-spinner>
  </div>
  }

  @if (!isLoading && profiles.data.length === 0) {
  <div class="empty-state">
    <mat-icon class="empty-icon">person_outline</mat-icon>
    <p>{{variables?.noProfilesFound || 'No se encontraron perfiles'}}</p>
  </div>
  }

  @if (!isLoading && profiles.data.length > 0) {
  <div class="table-filters">
    @if (showCostCenterFilter) {
    <mat-form-field appearance="outline" class="cost-center-filter-field">
      <mat-label>{{variables?.center || 'Centro'}}</mat-label>
      <mat-select [value]="selectedCostCenter" (selectionChange)="applyCostCenterFilter($event.value)">
        <mat-option>
          <ngx-mat-select-search
            [formControl]="costCenterSearchCtrl"
            [placeholderLabel]="variables?.searchCenter || 'Buscar centro'"
            [noEntriesFoundLabel]="variables?.noCentersFound || 'No se encontraron centros'">
          </ngx-mat-select-search>
        </mat-option>
        <mat-option value="">{{variables?.allCenters || 'Todos los centros'}}</mat-option>
        @for (center of filteredAvailableCostCenters; track center) {
        <mat-option [value]="center">{{getCostCenterLabel(center)}}</mat-option>
        }
      </mat-select>
    </mat-form-field>
    }

  </div>

  <table mat-table [dataSource]="profiles" matSort class="profiles-table">
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{variables?.name || 'Nombre'}}</th>
      <td mat-cell *matCellDef="let profile">
        <span class="profile-name">{{profile.name}}</span>
      </td>
    </ng-container>
    <ng-container matColumnDef="center">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{variables?.center || 'Centro'}}</th>
      <td mat-cell *matCellDef="let profile">
        <span class="center-text">{{profile.center || '-'}}</span>
      </td>
    </ng-container>
    <ng-container matColumnDef="description">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{variables?.description || 'Descripción'}}</th>
      <td mat-cell *matCellDef="let profile">{{profile.description}}</td>
    </ng-container>
    <ng-container matColumnDef="costPerHour">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{variables?.costPerHour || 'Coste (€/hora)'}}</th>
      <td mat-cell *matCellDef="let profile">
        <span class="cost-badge">{{profile.costPerHour | number:'1.2-2'}} €/h</span>
      </td>
    </ng-container>
    <ng-container matColumnDef="lastModifiedDate">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{variables?.lastModified || 'Última modificación'}}</th>
      <td mat-cell *matCellDef="let profile">
        <span class="date-text">{{profile.lastModifiedDate || '-'}}</span>
      </td>
    </ng-container>
    <ng-container matColumnDef="usage">
      <th mat-header-cell *matHeaderCellDef>{{variables?.usage || 'Uso'}}</th>
      <td mat-cell *matCellDef="let profile">
        @if (getUsageCount(profile) > 0) {
        <span class="usage-badge used"
          matTooltip="{{getUsageCount(profile)}} {{variables?.usageInCatalogs || 'catálogos'}}">
          {{getUsageCount(profile)}}
        </span>
        }
        @if (getUsageCount(profile) === 0) {
        <span class="usage-badge not-used">
          {{variables?.notUsed || 'Sin uso'}}
        </span>
        }
      </td>
    </ng-container>
    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef>{{variables?.actions || 'Acciones'}}</th>
      <td mat-cell *matCellDef="let profile">
        <div class="action_buttons">
          <span (click)="isRestrictedRole ? null : openEditDialog(profile)"
            [class.disabled-action]="isRestrictedRole" class="icon-edit me-3 action_buttons-item"
            matTooltip="{{variables?.edit || 'Editar'}}">
            <img src="../../../../assets/svg/EditWhite.svg" alt="Edit Icon" width="20px">
          </span>
          <span (click)="isRestrictedRole ? null : deleteProfile(profile)"
            [class.disabled-action]="isRestrictedRole" class="icon-close me-1 action_buttons-item"
            matTooltip="{{variables?.remove || 'Eliminar'}}">
            <img src="../../../../assets/svg/BinWhite.svg" alt="Bin Icon" width="15px">
          </span>
        </div>
      </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
  }

  <mat-paginator [hidden]="isLoading || profiles.data.length === 0" [pageSize]="10" [pageSizeOptions]="[5, 10, 25]" showFirstLastButtons></mat-paginator>

  <div class="perfiles-footer-actions">
    <app-button typeBtn="primary" class="addItemsInCatalogStepBtn" [disabled]="isRestrictedRole" (click)="openAddDialog()"
      message="{{variables?.addProfile || 'Agregar Perfil'}}"></app-button>
  </div>
</div>